import { IQoutaType, IQoutaTypeHistoric } from "@/core/model/sys/IQuotaType";
import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";

export default class QuotaTypeService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public QoutaTypeHistoric():IQoutaTypeHistoric
  {
    return {
      StartDate:new Date(),
      Year:0,
      Quota:0,      
      Active:true,
      Deleted:false,
    }
  }
  public NewQuota():IQoutaType
  {
    return {
        Gid: this.NewId,
        Code: '',
        QuotaName: '',
        Quota: 0,
        CreatedBy: 0,
        CreatedTime: new Date(),
        ModifiedBy: 0,
        ModifiedTime: new Date(),
        CreatedByEmployee: null,
        ModifiedByEmployee:null,
        Active: true,
        IsNew:true,
        QoutaTypeHistorics:null
    };
  }
  public async ListQoutaType():Promise<IQoutaType[]>
  {
    const cuotas = Array<IQoutaType>();
    const response:IServiceResponse = await this.Get('IndexQuotas/ListQoutaType',null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        cuotas.push({...element});  
      }      
    }    
    return cuotas;
  }   
  public async SaveQuota(cuota:IQoutaType):Promise<string>
  {    
    if(cuota.QoutaTypeHistorics)
    {
      for (const h of cuota.QoutaTypeHistorics) 
      {
        if(h && h.StartDate)
        {
          h.Year = h.StartDate.getFullYear();          
        }
      }      
    }
    const response:IServiceResponse =  await this.Post('IndexQuotas/SaveQuota',cuota,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response.Result;
    }
    else
      return "";
  } 
}